import { React, useEffect, useState } from 'react';
import Axios from 'axios';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { Container, Alert, Spinner, Input, Button } from 'reactstrap';
import logo from '../../images/nerds_logo.jpg';
import '../home/style.css'

export const Home = (id) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [customerData, setCustomerData] = useState(null);
    const [selectedOption, setSelectedOption] = useState('-');
    const [selectionError, setSelectionError] = useState(null);
    const [confirmRenew, setConfirmRenew] = useState(false);
    const [confirmCancel, setConfirmCancel] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const id = queryParams.get('id');
            const code = queryParams.get('code');
            const fetchData = async () => {
                try {
                    const result = await Axios.get(`/api/renew?id=${id}&code=${code}`);
                    if (result.status === 200) {
                        setCustomerData({ ...result.data })
                        setLoading(false);
                    } else {
                        setError('Unable find valid subscription details. Please contact us on 0800 633 326 or try again.');
                        setLoading(false);
                    }
                } catch (err) {
                    setError('Unable find valid subscription details. Please contact us on 0800 633 326 or try again.');
                    setLoading(false);
                }
            };
            fetchData();

        } catch (err) {
            setError('Unable find valid subscription details. Please contact 0800 633 326 or try again.');
            setLoading(false);
        }


    }, []);



    const sendRenew = async () => {
        setLoading(true);
        let obj = {
            customerData: { ...customerData },
            productId: selectedOption,
        }
        console.log(obj)
        try {
            const result = await Axios.post('/api/createinvoice', { ...obj });
            setLoading(false);
            setSuccess(true);
        } catch (err) {
            setLoading(false);
            setSuccess(false);
            setError('Something went wrong!');
            setConfirmCancel(false);
            setConfirmRenew(false);
        }

    }

    const sendCancel = async () => {
        setLoading(true);
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get('id');
        const code = queryParams.get('code');
        try {
            const result = await Axios.get(`/api/cancel?id=${id}&code=${code}`);
            setLoading(false);
            setSuccess(true);
            window.location.reload();
        } catch (err) {
            setLoading(false);
            setSuccess(false);
            setError('Something went wrong!');
            setConfirmCancel(false);
            setConfirmRenew(false);
        }
    }

    const confirm = () => {
        if (selectedOption === '-') {
            setSelectionError('Please select a valid option')
        } else {
            setConfirmRenew(true);
        }
    }

    const renderError = () => {
        return (
            <Alert color='danger'>{error}</Alert>
        )
    }

    const renderConfirmCancel = () => {
        return (
            <div>
                <div className="info-wrapper">
                    <p>Are you sure you don't want to renew?</p>
                </div>
                <div className='button-wrapper'>
                    <Button color='success' className='button-eset' outline onClick={() => sendCancel()}>Yes, Cancel</Button>
                    <Button color='danger' className='button-eset' outline onClick={() => setConfirmCancel(false)}>No, go back</Button>
                </div>
            </div>
        )
    }

    const renderSuccess = () => {
        return (
            <div className="info-wrapper">
                <Alert type='success'>Success! Your subscription will be renewed. An invoice will be sent to your email shortly. For any questions please call 0800 633 326</Alert>
            </div>
        )
    }

    const renderOptions = () => {
        return _.map(customerData.productItems, (item, index) => {
            return <option key={index} value={item.repairShoprId}>${item.priceRetail} - {item.description}</option>
        })
    }

    const renderPicker = () => {
        if (customerData.renew.renewed) {
            return (
                <div className="info-wrapper">
                    <h4 className='w-100 text-center'>Hi {customerData.name}</h4>
                    <p className='w-100 text-center m-0'>Your Antivirus subscription has already been renewed.</p>
                    <div className='call-us-wrapper'>
                        <p className='w-100 text-center'>Questions?</p>
                        <p>Give us a call on 0800 633 326</p>
                    </div>
                </div>
            )
        }
        if (customerData.cancelled.isCancelled) {
            return (
                <div>
                    <div className="info-wrapper">
                        <h4 className='w-100 text-center'>Hi {customerData.name}</h4>
                        <p className='w-100 text-center m-0'>Your Antivirus subscription has already been cancelled.</p>
                        <div className='call-us-wrapper'>
                            <p className='w-100 text-center'>Questions?</p>
                            <p>Give us a call on 0800 633 326</p>
                        </div>
                    </div>
                </div>
            )
        }

        if (!error && !confirmRenew && !confirmCancel) {
            return (
                <div>
                    <div className="info-wrapper">
                        <h4 className='w-100 text-center mt-3'>Hi {customerData.name}</h4>
                        <p className='w-100 text-center m-0'>Your Antivirus subscription is due for renewal</p>
                        <p className='w-100 text-center m-0'>To renew your subscription please select an option from below.</p>
                        <Input type='select' className='eset-select' onChange={(e) => setSelectedOption(e.target.value)} defaultValue={selectedOption}>
                            <option value='-'>Select</option>
                            {renderOptions()}
                        </Input>

                    </div>
                    <div className='button-wrapper mt-4'>
                        <Button className='button-eset' color='success' outline onClick={() => confirm()}>Renew Now</Button>
                        <Button className='button-eset' color='danger' outline onClick={() => setConfirmCancel(true)}>No, Cancel</Button>
                    </div>
                    <div className='call-us-wrapper'>
                        <p className='w-100 text-center'>Questions?</p>
                        <p>Give us a call on 0800 633 326</p>
                    </div>
                </div>
            )
        } else if (error && !confirmRenew && !confirmCancel) {
            return (
                <div className="font-mono text-center flex flex-wrap justify-center py-8">
                    {renderError()}
                </div>
            )
        } else if (!error && confirmRenew && !success) {
            return (
                <div>
                    <div>
                        <p className='text-center'>You've selected the below product</p>
                        {_.map(customerData.productItems, (prod, index) => {
                            if (prod.repairShoprId === parseInt(selectedOption)) {
                                return <p className='font-mono font-semibold text-center' key={index}>${prod.priceRetail} - {prod.description}</p>
                            }
                        })}
                    </div>
                    <div className='button-wrapper'>
                        <Button color='success' className='button-eset' outline onClick={() => sendRenew()}>Yes, Renew</Button>
                        <Button color='danger' className='button-eset' outline onClick={() => setConfirmRenew(false)} >No, go back</Button>
                    </div>
                </div>
            )
        } else if (!error && confirmRenew && success) {
            return renderSuccess()
        } else if (!error && !confirmRenew && confirmCancel) {
            return renderConfirmCancel()
        }
    }


    if (error) {
        return (
            <Container fluid={true} className='main-wrapper'>
                <Helmet>
                    <title>Renewals</title>
                    <meta name="description" content="Need a Nerd Antivirus Renewal Service" />
                </Helmet>
                <Container className='inner-wrapper'>
                    <img src={logo} className='nerds-logo' alt='logo' />
                    {renderError()}
                </Container>
            </Container>
        )
    }
    return (
        <Container fluid={true} className='main-wrapper'>
            <Helmet>
                <title>Renewals</title>
                <meta name="description" content="Need a Nerd Antivirus Renewal Service" />
            </Helmet>
            <Container className='inner-wrapper'>
                <img src={logo} className='nerds-logo' alt='logo' />
                {loading ? <Spinner color='info' /> : renderPicker()}
            </Container>
        </Container>
    )
}